import { createReducer, on } from '@ngrx/store';
import { initialState } from '../shared.state';
import { SharedActions } from '../actions';
import * as legalEntitiesAction from '../actions/legal-entity.action';

export const sharedReducerFn = createReducer(
    initialState,
    on(SharedActions.setMsalInfo, (state, { msalInfo }) => ({
        ...state,
        msalInfo,
    })),
    on(SharedActions.setAccessToken, (state, { accessToken }) => ({
        ...state,
        accessToken,
    })),
    on(SharedActions.setRedirectUrl, (state, { redirectUrl }) => ({
        ...state,
        redirectUrl,
    })),
    on(SharedActions.setCurrency, (state, { currency }) => ({
        ...state,
        currency,
    })),
    on(SharedActions.setUserLegalEntities, (state, { userLegalEntities }) => ({
        ...state,
        userLegalEntities,
    })),
    on(SharedActions.setDefaultLegalEntity, (state, { defaultLegalEntity }) => ({
        ...state,
        defaultLegalEntity,
    })),
    on(SharedActions.setUserRoles, (state, { userRoles }) => ({
        ...state,
        userRoles,
    })),
    on(SharedActions.setDateFormat, (state, { dateFormat }) => ({
        ...state,
        dateFormat,
    })),
    on(SharedActions.setSelectedLanguage, (state, { selectedLanguage }) => ({
        ...state,
        selectedLanguage,
    })),
    on(SharedActions.setQuery, (state, { query }) => ({
        ...state,
        query
    })),
    on(SharedActions.setCarts, (state, { carts }) => ({
        ...state,
        cartsData: {
            ...state.cartsData,
            carts
        }
    })),
    on(SharedActions.setActiveCart, (state, { activeCart }) => ({
        ...state,
        cartsData: {
            ...state.cartsData,
            activeCart
        }
    })),
    on(SharedActions.setCartId, (state, { cartId }) => ({
        ...state,
        cartsData: {
            ...state.cartsData,
            cartId
        }
    })),
    on(SharedActions.createNewCart, (state) => ({
        ...state,
        newCart: {
            ...state.newCart,
            loading: true,
            success: null,
            error: null
        }
    })),
    on(SharedActions.createNewCartSuccess, (state, { payload }) => ({
        ...state,
        newCart: {
            ...state.newCart,
            loading: null,
            success: payload,
            error: null
        }
    })),
    on(SharedActions.createNewCartFail, (state, { error }) => ({
        ...state,
        newCart: {
            ...state.newCart,
            loading: null,
            success: null,
            error
        }
    })),
    on(SharedActions.setParamsCartGroupId, (state, { paramsCartGroupId }) => ({
        ...state,
        paramsCartGroupId,
    })),
    on(SharedActions.setCheckoutCartGroupId, (state, { checkoutCartGroupId }) => ({
        ...state,
        checkoutCartGroupId
    })),
    on(SharedActions.setCartCode, (state, { cartCode }) => ({
        ...state,
        cartCode,
    })),
    on(SharedActions.setSecondaryCartCode, (state, { secondaryCartCode }) => ({
        ...state,
        secondaryCartCode,
    })),
    on(SharedActions.setUserProfileData, (state, { userProfileData }) => ({
        ...state,
        userProfileData,
    })),
    on(SharedActions.setCartUserData, (state, { cartUserData }) => ({
        ...state,
        cartUserData,
    })),
    on(SharedActions.loadCartsByLegalEntity, state => ({
        ...state,
        cartsData: {
            ...state.cartsData,
            loading: true,
            error: null,
        }
    })),
    on(SharedActions.loadCartsByLegalEntitySuccess, (state, { payload }) => {
        const activeCartVal = (payload.carts?.length > 0 && payload.carts.at(0)['isActiveCart']) ? payload.carts[0] : null;
        return {
            ...state,
            cartsData: {
                ...state.cartsData,
                loading: false,
                error: null,
                carts: payload.carts,
                activeCart: activeCartVal,
                cartId: activeCartVal?.code ?? null,
            }
        }
    }),
    on(SharedActions.loadCartsByLegalEntityFail, (state, { error }) => ({
        ...state,
        cartsData: {
            ...state.cartsData,
            loading: false,
            error: error,
        }
    })),
    on(legalEntitiesAction.LoadLegalEntityListSuccess, (state, { userLegalEntities }) => ({
        ...state,
        userLegalEntities
    })),
    on(SharedActions.rejectAccessRequestSuccess, (state,) => ({
        ...state,
        rejectSuccess: true
    })),
    on(SharedActions.rejectAccessRequestFail, (state, { payload }) => ({
        ...state,
        error: payload
    })),
    on(SharedActions.successApiResponseReset, (state,) => ({
        ...state,
        rejectSuccess: false
    })),
);